import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useData } from "../backend/firebase";
import { Navigate } from 'react-router-dom';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { AVAILABLE_IMAGES, getImagePath } from '../utils/imageRegistry';
import ConfirmationModal from '../components/ConfirmationModal';

// --- FIX: Import & Register Resizer ---
import BlotFormatter from 'quill-blot-formatter';


// --- NEW: Import Table Module ---
import * as QuillTableUI from 'quill-table-ui';
import 'quill-table-ui/dist/index.css';

// Register the Table UI module


// --- NEW: Register Table Module ---


// --- FIX: Define Custom Image Blot to persist Styles ---
// This tells the editor: "Don't delete the style="..." attribute when saving!"
const BaseImage = Quill.import('formats/image');

class CustomImage extends BaseImage {
  static create(value) {
    const node = super.create(value);
    return node;
  }

  static formats(domNode) {
    // Allow specific attributes to be read from the DOM
    const map = {};
    if (domNode.hasAttribute('height')) map.height = domNode.getAttribute('height');
    if (domNode.hasAttribute('width')) map.width = domNode.getAttribute('width');
    if (domNode.hasAttribute('style')) map.style = domNode.getAttribute('style');
    return map;
  }

  format(name, value) {
    // Allow specific attributes to be written to the DOM
    if (name === 'height' || name === 'width') {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else if (name === 'style') {
      if (value) {
        this.domNode.setAttribute('style', value);
      } else {
        this.domNode.removeAttribute('style');
      }
    } else {
      super.format(name, value);
    }
  }
}

// Register the custom image logic
Quill.register('formats/image', CustomImage, true);
Quill.register('modules/blotFormatter', BlotFormatter);
Quill.register({'modules/tableUI': QuillTableUI.default}, true);
// --- EDITOR COMPONENT ---
const RenderEditor = ({ value, onChange }) => {
    const [editorBg, setEditorBg] = useState("#2D2B3F");
    const quillRef = useRef(null);

    // Image Handler: Prompts for URL
    const imageHandler = () => {
        const url = prompt("Paste the Image URL from the Media Tab:");
        if (url) {
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection();
            // If selection is null (editor lost focus), insert at index 0
            const index = range ? range.index : 0;
            quill.insertEmbed(index, 'image', url);
        }
    };

    const tableHandler = () => {
        const quill = quillRef.current.getEditor();
        const table = quill.getModule('table');
        table.insertTable(3, 3); // Inserts a 3x3 table
    };

    // Memoize modules config
    const modules = useMemo(() => ({
        // 1. Image Resize Module
        blotFormatter: {
            overlay: {
                style: {
                    border: '2px solid #6C5DD3', // Visual feedback
                }
            }
        },
        table: true,      // Enable the native table module
        tableUI: true,    // Enable the context menu (Right-click/Tooltip)
        // 2. Toolbar
        toolbar: {
            container: [
                [{ 'font': [] }, { 'size': [] }],
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'color': [] }, { 'background': [] }],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                [{ 'align': [] }],
                ['link', 'image', 'clean', 'table']
            ],
            handlers: {
                image: imageHandler,
                table: tableHandler 
            }
        }
    }), []);

    return (
      <div>
          <div style={{display:'flex', alignItems:'center', gap: 10, marginBottom: 5}}>
              <label style={{fontSize: 12, color: '#8F9EB5'}}>Editor Background:</label>
              <input 
                  type="color" 
                  value={editorBg} 
                  onChange={(e) => setEditorBg(e.target.value)} 
                  style={{width: 30, height: 30, border: 'none', cursor: 'pointer', background: 'transparent'}} 
                  title="Change background to see text better"
              />
              <button onClick={()=>setEditorBg("#ffffff")} style={{background:'white', border:'1px solid #ccc', fontSize:10, cursor:'pointer', color:'black', padding:'2px 6px', borderRadius:4}}>Light</button>
              <button onClick={()=>setEditorBg("#2D2B3F")} style={{background:'#2D2B3F', border:'1px solid #ccc', fontSize:10, cursor:'pointer', color:'white', padding:'2px 6px', borderRadius:4}}>Default (Dark)</button>
              <button onClick={()=>setEditorBg("#000000")} style={{background:'black', border:'1px solid #ccc', fontSize:10, cursor:'pointer', color:'white', padding:'2px 6px', borderRadius:4}}>Black</button>
          </div>
          {/* Use a wrapper div with relative positioning to help the overlay calculate position */}
          <div style={{color: editorBg === '#ffffff' ? 'black' : 'white', position: 'relative'}}>
              <ReactQuill 
                  ref={quillRef}
                  theme="snow" 
                  value={value} 
                  onChange={onChange} 
                  modules={modules} 
                  style={{backgroundColor: editorBg}} 
              />
          </div>
      </div>
    );
};

const BracketEditor = ({ bracketData, setBracketData, teams }) => {
    const sections = [
        { id: 'main', label: '🏆 Knockout A Bracket' },
        { id: 'consolation', label: '🛡️ Knockout B Bracket' }
    ];

    const matchKeys = {
        main: ['api1', 'api2', 'aqf1', 'aqf2', 'aqf3', 'aqf4', 'asf1', 'asf2', 'afinal', 'abronze'],
        consolation: ['bpi1', 'bpi2', 'bqf1', 'bqf2', 'bqf3', 'bqf4', 'bsf1', 'bsf2', 'bfinal', 'bbronze'],
    };

    const updateMatch = (section, matchId, field, value) => {
        setBracketData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [matchId]: {
                    ...prev[section]?.[matchId],
                    [field]: value
                }
            }
        }));
    };

    return (
        <div>
            {sections.map(section => (
                <div key={section.id} style={{marginBottom: 30, background: 'rgba(0,0,0,0.2)', padding: 15, borderRadius: 12}}>
                    <h3 style={{borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: 10, marginTop: 0}}>{section.label}</h3>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 15}}>
                        {matchKeys[section.id].map(mid => {
                            const match = bracketData[section.id]?.[mid] || {};
                            return (
                                <div key={mid} style={{background: 'rgba(255,255,255,0.05)', padding: 15, borderRadius: 8}}>
                                    <div style={{fontWeight: 'bold', marginBottom: 10, color: '#6C5DD3', textTransform: 'uppercase', fontSize: 12}}>{mid}</div>
                                    
                                    {/* Team 1 */}
                                    <div style={{display: 'flex', gap: 5, marginBottom: 5}}>
                                        <select 
                                            value={match.team1 || ''} 
                                            onChange={e => updateMatch(section.id, mid, 'team1', e.target.value)}
                                            style={{flex: 1, padding: 5, background: '#222', color: '#fff', border: '1px solid #444', borderRadius: 4}}
                                        >
                                            <option value="">Select Team 1...</option>
                                            {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                        </select>
                                        <input 
                                            placeholder="#" 
                                            value={match.score1 || ''} 
                                            onChange={e => updateMatch(section.id, mid, 'score1', e.target.value)}
                                            style={{width: 40, background: '#222', color: '#fff', border: '1px solid #444', borderRadius: 4, textAlign: 'center'}}
                                        />
                                    </div>

                                    {/* Team 2 */}
                                    <div style={{display: 'flex', gap: 5, marginBottom: 10}}>
                                        <select 
                                            value={match.team2 || ''} 
                                            onChange={e => updateMatch(section.id, mid, 'team2', e.target.value)}
                                            style={{flex: 1, padding: 5, background: '#222', color: '#fff', border: '1px solid #444', borderRadius: 4}}
                                        >
                                            <option value="">Select Team 2...</option>
                                            {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                        </select>
                                        <input 
                                            placeholder="#" 
                                            value={match.score2 || ''} 
                                            onChange={e => updateMatch(section.id, mid, 'score2', e.target.value)}
                                            style={{width: 40, background: '#222', color: '#fff', border: '1px solid #444', borderRadius: 4, textAlign: 'center'}}
                                        />
                                    </div>

                                    {/* Winner Toggle */}
                                    <select 
                                        value={match.winner || ''}
                                        onChange={e => updateMatch(section.id, mid, 'winner', e.target.value)}
                                        style={{width: '100%', padding: 5, background: '#333', color: '#FFD700', border: 'none', borderRadius: 4, fontWeight: 'bold'}}
                                    >
                                        <option value="">No Winner Set</option>
                                        <option value="team1">Winner: Team 1</option>
                                        <option value="team2">Winner: Team 2</option>
                                    </select>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
};

const Admin = () => {
  const { 
      userRole, allUsers,
      user, schedule, conditionsText, teams, standings, homeContent, navigation, donationsContent, customPages, globalStyle,
      addEvent, updateEvent, deleteEvent, updateConditions, saveTeams, saveStandings, saveHomeContent, saveNavigation, saveDonationsContent,
      addCustomPage, updateCustomPage, deleteCustomPage, saveGlobalStyle, updateUserRoleData, brackets, saveBrackets
  } = useData();
  
  const [activeTab, setActiveTab] = useState("schedule");
  const [statusMsg, setStatusMsg] = useState(""); 

  // ... [Keep ALL existing state variables (schedForm, teamDraft, etc...)] ...
  // (I am omitting the state declarations here to save space, but keep them exactly as they were in your previous file)
  const [schedEditingId, setSchedEditingId] = useState(null);
  const [schedForm, setSchedForm] = useState({ team1: "", team2: "", startTime: "", endTime: "", links: [], description: "", result: "" });
  const [teamEditingId, setTeamEditingId] = useState(null);
  const [teamDraft, setTeamDraft] = useState({ name: "", color: "#ffffff", logo: "", logoUrl: "", bio: "" });
  const [standingsDraft, setStandingsDraft] = useState([]); 
  const [rulesDraft, setRulesDraft] = useState("");
  const [homeDraft, setHomeDraft] = useState({ welcomeText: "", welcomeVideo: "" });
  const [donationsDraft, setDonationsDraft] = useState({ text: "", link: "", thankYouText: ""});
  const [navDraft, setNavDraft] = useState([]);
  const [styleDraft, setStyleDraft] = useState({ font: 'Inter', accentColor: '#6C5DD3', bgStart: '#7e6cd9', bgEnd: '#4a32e1', sidebarBg: '#110e22', cardBg: 'rgba(20, 20, 35, 0.6)' });
  const [pageEditingId, setPageEditingId] = useState(null);
  const [pageDraft, setPageDraft] = useState({ title: "", slug: "", content: "" });
  const [bracketDraft, setBracketDraft] = useState({ main: {}, consolation: {} });

  const [homeSections, setHomeSections] = useState([]);
  const [pageMeta, setPageMeta] = useState({ title: "", slug: "" }); // Meta data separate
  const [pageSections, setPageSections] = useState([]); // List of sections for current page
  const [modalState, setModalState] = useState({open: false, title: '', message: '', action: null });
  

  // --- SYNC DATA ON LOAD ---
  useEffect(() => {
    if(conditionsText && rulesDraft === "") setRulesDraft(conditionsText);
    if(standings.length > 0 && standingsDraft.length === 0) setStandingsDraft(standings);
    if(homeContent) setHomeDraft(homeContent);
    if(brackets) setBracketDraft(brackets);

    if(homeContent) {
        if (homeContent.sections) {
            setHomeSections(homeContent.sections);
        } else if (homeContent.welcomeText || homeContent.welcomeVideo) {
            // Convert old format to new sections format seamlessly
            const migrated = [];
            if(homeContent.welcomeVideo) migrated.push({ id: 1, type: 'media', content: homeContent.welcomeVideo, visible: true });
            if(homeContent.welcomeText) migrated.push({ id: 2, type: 'card', content: homeContent.welcomeText, visible: true });
            setHomeSections(migrated);
        }
    }

    if(donationsContent) setDonationsDraft(donationsContent);
    if(navigation.length > 0 && navDraft.length === 0) setNavDraft(navigation);
    if(globalStyle) setStyleDraft(prev => ({...prev, ...globalStyle}));
  }, [conditionsText, standings, homeContent, navigation, donationsContent, globalStyle]);

  if (!user) return <Navigate to="/login" />;
  if (!(userRole?.role === 'admin')) return <Navigate to="/captain" />;
  // --- HELPERS ---
  const addHomeSection = (type) => {
      setHomeSections([...homeSections, { id: Date.now(), type, content: "", visible: true }]);
  };
  
  const updateHomeSection = (index, field, value) => {
      const updated = [...homeSections];
      updated[index][field] = value;
      setHomeSections(updated);
  };

  const moveHomeSection = (index, direction) => {
      const updated = [...homeSections];
      if (direction === -1 && index > 0) {
          [updated[index], updated[index - 1]] = [updated[index - 1], updated[index]];
      } else if (direction === 1 && index < updated.length - 1) {
          [updated[index], updated[index + 1]] = [updated[index + 1], updated[index]];
      }
      setHomeSections(updated);
  };

  const removeHomeSection = (index) => {
      if(!window.confirm("Delete this section?")) return;
      setHomeSections(homeSections.filter((_, i) => i !== index));
  };

  const handleSaveHome = async () => {
      // Save as 'sections' property in the home settings doc
      await saveWrapper(saveHomeContent, { sections: homeSections }, "Home Page Updated");
  };

  const confirmAction = (title, message, actionToPerform) => {
        setModalState({
            open: true,
            title: title,
            message: message,
            action: actionToPerform
        });
    };

  const addPageSection = (type) => setPageSections([...pageSections, { id: Date.now(), type, content: "", visible: true }]);
  const updatePageSection = (index, field, value) => { const u = [...pageSections]; u[index][field] = value; setPageSections(u); };
  const movePageSection = (index, dir) => { const u = [...pageSections]; if (dir===-1 && index>0) {[u[index], u[index-1]]=[u[index-1], u[index]]} else if(dir===1 && index<u.length-1) {[u[index], u[index+1]]=[u[index+1], u[index]]} setPageSections(u); };
  const removePageSection = (i) => { if(window.confirm("Delete section?")) setPageSections(pageSections.filter((_,x)=>x!==i)); };

  const handleEditPage = (p) => { 
      setPageEditingId(p.id); 
      
      // 1. Populate Title & Slug
      setPageDraft({ 
          title: p.title || "", 
          slug: p.slug || "" 
      });
      
      // 2. Populate Sections (The Fix)
      if (p.sections && Array.isArray(p.sections) && p.sections.length > 0) {
          // Load existing builder sections
          setPageSections(p.sections);
      } else if (p.content) {
          // LEGACY MIGRATION: If page has old text content but no sections, 
          // wrap it in a Glass Card so it appears in the builder.
          setPageSections([{
              id: Date.now(),
              type: 'card',
              content: p.content,
              visible: true
          }]);
      } else {
          // Empty page
          setPageSections([]);
      }
  };
  
  const handleSavePage = async () => {
      // 1. Debugging: Check console to see what is about to be saved
      console.log("Saving Page Payload:", pageDraft);

      // 2. Validation
      if(!pageDraft.title) return alert("Page Title is required");
      if(!pageDraft.slug && !pageEditingId) return alert("URL Slug is required");

      // 3. Prepare Slug
      // If editing, keep original slug. If new, sanitize the input.
      const cleanSlug = pageEditingId 
          ? pageDraft.slug 
          : pageDraft.slug.toLowerCase().trim().replace(/ /g, '-').replace(/[^\w-]+/g, '');

      // 4. Construct Payload
      const payload = { 
          title: pageDraft.title,
          slug: cleanSlug,
          content: pageDraft.content || "", // Legacy support
          sections: pageSections // <--- ADD THIS LINE
      };
      
      // 5. Database Operations
      if(pageEditingId) {
          await updateCustomPage(pageEditingId, payload);
      } else { 
          await addCustomPage(payload); 
          
          // Add to Navigation (Hidden by default)
          const link = `/page/${cleanSlug}`;
          const exists = navDraft.find(n => n.link === link);
          if(!exists) {
              const newNav = [...navDraft, { title: payload.title, link: link, visible: false, type: 'custom' }];
              setNavDraft(newNav); 
              await saveNavigation(newNav); 
          }
      }
      
      // 6. Reset Form
      setPageEditingId(null); 
      setPageDraft({ title: "", slug: "", content: "" });
      setPageSections([]); // <--- ADD THIS LINE TO CLEAR EDITOR
      
      setStatusMsg("✅ Page Saved"); 
      setTimeout(()=>setStatusMsg(""), 2000);
  };

  // --- UPDATED DELETE PAGE HANDLER ---
  const handleDeletePage = async (id) => { 
      if(!window.confirm("Delete this page? This cannot be undone.")) return; 
      
      // 1. Find page info BEFORE deletion
      const p = customPages.find(x => x.id === id); 
      
      // 2. Delete from Pages Collection
      await deleteCustomPage(id); 
      
      // 3. Update Navigation
      if(p) {
          const linkToRemove = `/page/${p.slug}`;
          const newNav = navDraft.filter(n => n.link !== linkToRemove);
          setNavDraft(newNav); // Update local state immediately
          await saveNavigation(newNav); // Sync to DB
      }
      
      setStatusMsg("✅ Page Deleted"); setTimeout(()=>setStatusMsg(""), 2000);
  };

  const saveWrapper = async (fn, arg, msg="Saved!") => {
      setStatusMsg("Saving...");
      if(await fn(arg)) { 
          setStatusMsg("✅ " + msg); 
          setTimeout(()=>setStatusMsg(""), 2000); 
      } else { 
          setStatusMsg("❌ Error"); 
      }
  };

//   const renderSvgPreview = (svgString) => {
//       if(!svgString) return null;
//       const dataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;
//       return <img src={dataUrl} alt="preview" style={{width: 40, height: 40, objectFit: 'contain', background: '#333', borderRadius: 4, border: '1px solid #555'}} />;
//   };

  // --- UPDATED PREVIEW HELPER ---
  // This handles both SVGs (strings) and standard images (filenames)
  const renderLogoPreview = (teamData) => {
      // 1. Priority: Uploaded SVG
      if (teamData.logo) {
          const dataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(teamData.logo)}`;
          return <img src={dataUrl} alt="preview" style={{width: 40, height: 40, objectFit: 'contain', background: 'rgba(255,255,255,0.1)', borderRadius: 4, padding: 2}} />;
      }
      // 2. Secondary: Selected Media Image
      if (teamData.logoUrl) {
          return <img src={getImagePath(teamData.logoUrl)} alt="preview" style={{width: 40, height: 40, objectFit: 'contain', background: 'rgba(255,255,255,0.1)', borderRadius: 4, padding: 2}} />;
      }
      // 3. Fallback: Color Box
      return <div style={{width: 40, height: 40, background: teamData.color || '#333', borderRadius: 4, border: '1px solid #555'}}></div>;
  };

  // --- NEW: MEDIA HELPER ---
  const copyToClipboard = (text, msg) => {
      navigator.clipboard.writeText(text);
      setStatusMsg(`✅ ${msg}`);
      setTimeout(() => setStatusMsg(""), 2000);
  };

  // ... [Keep all other handlers: Teams, Schedule, Standings, Custom Pages, Nav, Users] ...
  // (I am assuming you kept the handlers from the previous full code block)
  const handleLogoFileChange = (e) => { const f=e.target.files[0]; if(!f)return; const r=new FileReader(); r.onload=(ev)=>setTeamDraft(p=>({...p, logo:ev.target.result})); r.readAsText(f); };
  const handleTeamSubmit = async () => { const t = { ...teamDraft, id: teamEditingId || Date.now() }; const list = teamEditingId ? teams.map(x=>x.id===teamEditingId?t:x) : [...teams, t]; saveWrapper(saveTeams, list, "Team Saved"); setTeamDraft({name:"", color:"#fff", logo:"", logoUrl: "", bio: ""}); setTeamEditingId(null); document.getElementById('logo-upload').value="";};
  const startEditTeam = (t) => { setTeamEditingId(t.id); setTeamDraft(t); };
  const cancelEditTeam = () => { setTeamEditingId(null); setTeamDraft({ name: "", color: "#ffffff", logo: "", logoUrl: "", bio: "" }); };
  const handleDeleteTeam = (id) => { if(window.confirm("Remove?")) saveWrapper(saveTeams, teams.filter(t=>t.id!==id), "Team Removed"); };
  const handleAddLink = () => setSchedForm({ ...schedForm, links: [...schedForm.links, { url: "", label: "", teamId: "" }] });
  const handleLinkChange = (i, f, v) => { const l = [...schedForm.links]; if(typeof l[i]==='string') l[i]={url:l[i],label:"",teamId:""}; l[i] = {...l[i], [f]:v}; setSchedForm({...schedForm, links:l}); };
  const handleRemoveLink = (i) => setSchedForm({...schedForm, links: schedForm.links.filter((_,x)=>x!==i)});
  const handleSchedSubmit = async () => { const l = schedForm.links.filter(x=>x.url&&x.url.trim()!==""); let title = schedForm.title || "Bridge Match"; if(schedForm.team1 && schedForm.team2) { const t1 = teams.find(t => t.id.toString() === schedForm.team1.toString()); const t2 = teams.find(t => t.id.toString() === schedForm.team2.toString()); title = `${t1?.name || "TBA"} vs ${t2?.name || "TBA"}`; } const p = {...schedForm, title, links:l}; if(schedEditingId) await updateEvent(schedEditingId, p); else await addEvent(p); setSchedEditingId(null); setSchedForm({ team1:"", team2:"", startTime:"", endTime:"", links:[], description:"", result:"" }); saveWrapper(async()=>true, null, "Match Saved"); };
  const startEditSched = (i) => { setSchedEditingId(i.id); let l = i.links || (i.link ? [{url:i.link,label:"",teamId:""}] : []); setSchedForm({...i, links:l, result: i.result||""}); };
  const cancelEditSched = () => { setSchedEditingId(null); setSchedForm({ team1:"", team2:"", startTime:"", endTime:"", links:[], description:"", result:"" }); };
  const deleteSched = (id) => { if(window.confirm("Delete?")) deleteEvent(id); };
  const addStandingSection = () => setStandingsDraft([...standingsDraft, { id: Date.now(), title: "New Bracket", rows: [] }]);
  const updateSectionTitle = (idx, t) => { const u = [...standingsDraft]; u[idx].title = t; setStandingsDraft(u); };
  const addRowToSection = (idx) => { const u = [...standingsDraft]; u[idx].rows.push({ teamId: "", stats: { "W": 0, "L": 0, "Pts": 0 } }); setStandingsDraft(u); };
  const updateRowTeam = (s, r, t) => { const u = [...standingsDraft]; u[s].rows[r].teamId = t; setStandingsDraft(u); };
  const updateRowStat = (s, r, k, v) => { const u = [...standingsDraft]; u[s].rows[r].stats[k] = v; setStandingsDraft(u); };
  const addStatColumn = (s, n) => { const u = [...standingsDraft]; u[s].rows.forEach(r => r.stats[n] = 0); setStandingsDraft(u); };
  const removeSection = (i) => {if(window.confirm("Delete?")) setStandingsDraft(standingsDraft.filter((_, x) => x !== i))};
  const removeRow = (s, r) => {if(window.confirm("Delete?"))  {const u = [...standingsDraft]; u[s].rows = u[s].rows.filter((_,x)=>x!==r); setStandingsDraft(u); }};
  const handleSaveStandings = () => saveWrapper(saveStandings, standingsDraft, "Standings Saved");
//   const handleSavePage = async () => { if(!pageDraft.title || !pageDraft.slug) return alert("Title and Slug required"); const cleanSlug = pageDraft.slug.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, ''); const payload = { ...pageDraft, slug: cleanSlug }; if(pageEditingId) await updateCustomPage(pageEditingId, payload); else { await addCustomPage(payload); const exists = navDraft.find(n => n.link === `/page/${cleanSlug}`); if(!exists) await saveNavigation([...navDraft, { title: payload.title, link: `/page/${cleanSlug}`, visible: true, type: 'custom' }]); } setPageEditingId(null); setPageDraft({ title: "", slug: "", content: "" }); setStatusMsg("✅ Page Saved"); setTimeout(()=>setStatusMsg(""), 2000); };
//   const handleEditPage = (p) => { setPageEditingId(p.id); setPageDraft(p); };
//   const handleDeletePage = async (id) => { if(!window.confirm("Delete?")) return; await deleteCustomPage(id); const p = customPages.find(x => x.id === id); if(p) await saveNavigation(navDraft.filter(n => n.link !== `/page/${p.slug}`)); };
  const moveNav = (idx, dir) => { const n = [...navDraft]; if(dir===-1&&idx>0){[n[idx],n[idx-1]]=[n[idx-1],n[idx]]} else if(dir===1&&idx<n.length-1){[n[idx],n[idx+1]]=[n[idx+1],n[idx]]} setNavDraft(n); };
  const handleUserUpdate = async (uid, field, value) => { await updateUserRoleData(uid, { [field]: value }); };

  const isAdmin = userRole?.role === 'admin';

  return (
    <div className="PageLayout">
        <div className="ContentWrapper">
            
            <div className="GlassCard" style={{padding: 0, display:'flex', flexDirection:'column'}}>
                
                <div className="GlassHeader" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <h1 className="SectionTitle" style={{margin: 0, fontSize: 24}}>
                        {isAdmin ? "Admin Dashboard" : "Captain's Quarters"}
                    </h1>
                    {statusMsg && <span style={{color: statusMsg.includes('Error')?'#FF5C5C':'#26A65B', fontWeight: 'bold'}}>{statusMsg}</span>}
                </div>

                <div className="AdminContainer" style={{padding: 20}}>
                    
                    {/* --- SIDEBAR --- */}
                    <div className="AdminSidebar">
                        {isAdmin ? (
                            <>
                                <button className={activeTab==='schedule'?'active':''} onClick={()=>setActiveTab('schedule')}>📅 Schedule</button>
                                <button className={activeTab==='pages'?'active':''} onClick={()=>setActiveTab('pages')}>📄 Custom Pages</button>
                                <button className={activeTab==='teams'?'active':''} onClick={()=>setActiveTab('teams')}>🛡️ Teams</button>
                                <button className={activeTab==='users'?'active':''} onClick={()=>setActiveTab('users')}>👥 Users</button>
                                <button className={activeTab==='media'?'active':''} onClick={()=>setActiveTab('media')}>🖼️ Media</button> {/* NEW TAB */}
                                <button className={activeTab==='brackets'?'active':''} onClick={()=>setActiveTab('brackets')}>⚔️ Brackets</button>
                                <button className={activeTab==='standings'?'active':''} onClick={()=>setActiveTab('standings')}>🏆 Standings</button>
                                <div style={{height:1, background:'rgba(255,255,255,0.1)', margin:'5px 0'}}></div>
                                <button className={activeTab==='home'?'active':''} onClick={()=>setActiveTab('home')}>🏠 Home</button>
                                <button className={activeTab==='donate'?'active':''} onClick={()=>setActiveTab('donate')}>💰 Donations</button>
                                <button className={activeTab==='rules'?'active':''} onClick={()=>setActiveTab('rules')}>📜 Rules</button>
                                <button className={activeTab==='nav'?'active':''} onClick={()=>setActiveTab('nav')}>🔗 Navigation</button>
                                <button className={activeTab==='style'?'active':''} onClick={()=>setActiveTab('style')}>🎨 Style</button>
                            </>
                        ) : (
                            <button className="active">🔒 Locked</button>
                        )}
                    </div>

                    <div className="AdminMain ScrollArea">
                        {/* === BRACKETS TAB === */}
                        {activeTab === 'brackets' && (
                            <div>
                                <div style={{display:'flex', justifyContent:'space-between', marginBottom: 20}}>
                                    <h3>Manage Brackets</h3>
                                    <button className="PrimaryButton" onClick={()=>saveWrapper(saveBrackets, bracketDraft, "Brackets Saved")}>Save Changes</button>
                                </div>
                                <BracketEditor bracketData={bracketDraft} setBracketData={setBracketDraft} teams={teams} />
                            </div>
                        )}

                        {/* === MEDIA TAB (New) === */}
                        {activeTab === 'media' && (
                            <div>
                                <div style={{background:'rgba(255,255,255,0.05)', padding: 15, borderRadius: 8, marginBottom: 20}}>
                                    <h4 style={{margin: '0 0 10px 0'}}>How to add images:</h4>
                                    <ol style={{fontSize: 13, color: '#ccc', paddingLeft: 20, lineHeight: 1.5}}>
                                        <li>Add your image file (.png or .jpg) to the <code>public/assets/images/</code> folder in your project code.</li>
                                        <li>Open <code>src/utils/imageRegistry.js</code> and add an entry to the list.</li>
                                        <li>Rebuild/Restart the site. The image will appear below.</li>
                                    </ol>
                                </div>

                                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 20}}>
                                    {AVAILABLE_IMAGES.map((img, idx) => (
                                        <div key={idx} style={{background: 'rgba(0,0,0,0.3)', borderRadius: 8, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)'}}>
                                            <div style={{height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#111'}}>
                                                <img src={getImagePath(img.filename)} alt={img.name} style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain'}} />
                                            </div>
                                            <div style={{padding: 10}}>
                                                <div style={{fontWeight: 'bold', fontSize: 13, marginBottom: 5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{img.name}</div>
                                                <div style={{display: 'flex', flexDirection: 'column', gap: 5}}>
                                                    <button 
                                                        onClick={() => copyToClipboard(getImagePath(img.filename), "URL Copied")} 
                                                        style={{background: '#333', border: 'none', color: 'white', fontSize: 11, padding: '4px', borderRadius: 4, cursor: 'pointer'}}
                                                    >
                                                        Copy URL
                                                    </button>
                                                    <button 
                                                        onClick={() => copyToClipboard(`<img src="${getImagePath(img.filename)}" alt="${img.name}" style="width: 100%; max-width: 400px;" />`, "Embed Code Copied")} 
                                                        style={{background: '#6C5DD3', border: 'none', color: 'white', fontSize: 11, padding: '4px', borderRadius: 4, cursor: 'pointer'}}
                                                    >
                                                        Copy Embed Code
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* === CAPTAIN VIEW === */}
                        {!isAdmin && (
                            <div style={{textAlign:'center', padding: 50, opacity: 0.7}}>
                                <h2>Welcome, Captain!</h2>
                                <p>Your team management tools will appear here soon.</p>
                                {userRole?.teamId ? (
                                    <p style={{color: '#6C5DD3'}}>
                                        Assigned Team: <strong>{teams.find(t=>t.id.toString()===userRole.teamId)?.name || "Unknown"}</strong>
                                    </p>
                                ) : (
                                    <p style={{color: '#FF5C5C'}}>No team assigned yet.</p>
                                )}
                            </div>
                        )}

                        {/* ... [INCLUDE ALL OTHER TABS HERE: Schedule, Teams, Pages, etc.] ... */}
                        {/* (Paste the rest of the tabs from the previous full Admin.js) */}
                        
                        {/* === RULES TAB === */}
                        {activeTab === 'rules' && (
                            <div>
                                <div style={{display:'flex', justifyContent:'space-between', marginBottom:10}}>
                                    <h3>Conditions of Contest</h3>
                                    <button className="PrimaryButton" onClick={()=>saveWrapper(updateConditions, rulesDraft, "Rules Saved")}>Save Changes</button>
                                </div>
                                <RenderEditor value={rulesDraft} onChange={setRulesDraft} />
                            </div>
                        )}
                        {/* ... etc ... */}
                         {/* === HOME TAB === */}
                        {activeTab === 'home' && (
                            <div>
                                <div style={{display:'flex', justifyContent:'space-between', marginBottom: 10}}>
                                    <h3>Home Page Layout</h3>
                                    <button className="PrimaryButton" onClick={handleSaveHome}>Save Layout</button>
                                </div>

                                {/* Add Section Buttons */}
                                <div style={{display:'flex', gap: 10, marginBottom: 20, background: 'rgba(0,0,0,0.2)', padding: 10, borderRadius: 8}}>
                                    <button onClick={()=>addHomeSection('card')} style={{background: '#6C5DD3', border:'none', color:'white', padding:'8px 12px', borderRadius:6, cursor:'pointer'}}>+ Add Glass Card (Text/Image)</button>
                                    <button onClick={()=>addHomeSection('carousel')} style={{background: '#F39C12', border:'none', color:'white', padding:'8px 12px', borderRadius:6, cursor:'pointer'}}>+ Add Bio Carousel</button>
                                    <button onClick={()=>addHomeSection('media')} style={{background: '#26A65B', border:'none', color:'white', padding:'8px 12px', borderRadius:6, cursor:'pointer'}}>+ Add Standalone Video/Image</button>
                                </div>

                                {/* Sections List */}
                                {homeSections.map((section, index) => (
                                    <div key={section.id} style={{background: 'rgba(255,255,255,0.05)', borderRadius: 8, padding: 15, marginBottom: 15, border: '1px solid rgba(255,255,255,0.1)'}}>
                                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 10}}>
                                            <div style={{fontWeight: 'bold', color: section.type==='card' ? '#6C5DD3' : section.type==='carousel' ? '#F39C12' : '#26A65B'}}>
                                                {section.type === 'card' ? "📄 Glass Card (Text)" : section.type === 'carousel' ? "🎠 Bio Carousel" : "🎬 Standalone Media"}
                                            </div>
                                            <div style={{display:'flex', gap: 5}}>
                                                <button onClick={()=>moveHomeSection(index, -1)} disabled={index===0} style={{cursor:'pointer', background:'transparent', border:'none', color:'white'}}>▲</button>
                                                <button onClick={()=>moveHomeSection(index, 1)} disabled={index===homeSections.length-1} style={{cursor:'pointer', background:'transparent', border:'none', color:'white'}}>▼</button>
                                                <input type="checkbox" checked={section.visible} onChange={(e)=>updateHomeSection(index, 'visible', e.target.checked)} style={{cursor:'pointer', width:20, height:20}} title="Visible?" />
                                                <button onClick={()=>removeHomeSection(index)} style={{color:'#FF5C5C', background:'transparent', border:'none', cursor:'pointer', marginLeft: 10}}>Delete</button>
                                            </div>
                                        </div>

                                        {section.type === 'card' && (
                                            <RenderEditor value={section.content} onChange={(val) => updateHomeSection(index, 'content', val)} />
                                        )}

                                        {section.type === 'media' && (
                                            <div>
                                                <label style={{color: '#8F9EB5', fontSize: 12}}>Image URL or YouTube/Twitch Link</label>
                                                <input 
                                                    className="DarkInput" 
                                                    value={section.content} 
                                                    onChange={(e) => updateHomeSection(index, 'content', e.target.value)}
                                                    placeholder="https://..."
                                                />
                                                <div style={{fontSize: 11, color: '#555', marginTop: 5}}>
                                                    * Images will center automatically. Videos will auto-embed.
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                
                                <div style={{textAlign:'right', marginTop: 20}}><button className="PrimaryButton" onClick={handleSaveHome}>Save Layout</button></div>
                            </div>
                        )}

                        {/* === DONATE TAB === */}
                        {activeTab === 'donate' && (
                            <div>
                                <div style={{display:'flex', justifyContent:'space-between', marginBottom:10}}>
                                    <h3>Donations Page</h3>
                                    <button className="PrimaryButton" onClick={()=>saveWrapper(saveDonationsContent, donationsDraft, "Saved")}>Save Changes</button>
                                </div>
                                {/* NEW: Prize Pool Inputs */}
                                <div style={{display:'flex', gap: 15, marginBottom: 20, background: 'rgba(0,0,0,0.2)', padding: 15, borderRadius: 8}}>
                                    <div style={{flex: 1}}>
                                        <label style={{color: '#8F9EB5', fontSize: 12}}>Raised Amount ($)</label>
                                        <input 
                                            type="number" 
                                            className="DarkInput" 
                                            style={{marginBottom: 0}}
                                            value={donationsDraft.raised || ""} 
                                            onChange={(e) => setDonationsDraft({...donationsDraft, raised: e.target.value})} 
                                            placeholder="e.g. 2150"
                                        />
                                    </div>
                                    <div style={{flex: 1}}>
                                        <label style={{color: '#8F9EB5', fontSize: 12}}>Goal Amount ($)</label>
                                        <input 
                                            type="number" 
                                            className="DarkInput" 
                                            style={{marginBottom: 0}}
                                            value={donationsDraft.goal || ""} 
                                            onChange={(e) => setDonationsDraft({...donationsDraft, goal: e.target.value})} 
                                            placeholder="e.g. 5000"
                                        />
                                    </div>
                                </div>

                                <label style={{color: '#8F9EB5', fontSize: 12}}>Payment Link</label>
                                <input className="DarkInput" value={donationsDraft.link} onChange={(e) => setDonationsDraft({...donationsDraft, link: e.target.value})} />
                                <label style={{color: '#8F9EB5', fontSize: 12}}>Pitch Text</label>
                                <RenderEditor value={donationsDraft.text} onChange={(val) => setDonationsDraft({...donationsDraft, text: val})} />
                                <div style={{marginTop: 20}}>
                                    <label style={{color: '#8F9EB5', fontSize: 12}}>Thank You Wall (Bottom Card)</label>
                                    <RenderEditor 
                                    value={donationsDraft.thankYouText || ""} 
                                    onChange={(val) => setDonationsDraft({...donationsDraft, thankYouText: val})} 
                                    />
                                </div>
                            </div>
                        )}
                         {/* === CUSTOM PAGES TAB === */}
                        {activeTab === 'pages' && (
                            <div>
                                <div style={{display:'flex', justifyContent:'space-between', marginBottom: 15}}>
                                    <h3>{pageEditingId ? "Edit Page" : "Create Page"}</h3>
                                    {pageEditingId && <button onClick={()=>{setPageEditingId(null); setPageDraft({title:"", slug:""}); setPageSections([])}} style={{background:'transparent', border:'1px solid #555', color:'#ccc', borderRadius: 4, padding:'5px 10px', cursor: 'pointer'}}>Cancel</button>}
                                </div>
                                
                                {/* TITLE & SLUG INPUTS */}
                                <div style={{display:'flex', gap: 10, marginBottom: 20}}>
                                    <div style={{flex:1}}>
                                        <label style={{color:'#888', fontSize:12}}>Title</label>
                                        {/* Using pageDraft.title */}
                                        <input className="DarkInput" value={pageDraft.title} onChange={e=>setPageDraft(prev => ({...prev, title: e.target.value}))} />
                                    </div>
                                    <div style={{flex:1}}>
                                        <label style={{color:'#888', fontSize:12}}>Slug</label>
                                        {/* Using pageDraft.slug */}
                                        <input 
                                            className="DarkInput" 
                                            value={pageDraft.slug} 
                                            disabled={!!pageEditingId} // Lock slug when editing to prevent broken links
                                            style={{opacity: pageEditingId ? 0.5 : 1, cursor: pageEditingId ? 'not-allowed' : 'text'}}
                                            onChange={e=>setPageDraft(prev => ({...prev, slug: e.target.value}))} 
                                        />
                                    </div>
                                </div>

                                {/* PAGE SECTION BUILDER */}
                                <div style={{marginBottom: 20, background: 'rgba(0,0,0,0.2)', padding: 15, borderRadius: 8}}>
                                    <h4 style={{marginTop:0}}>Content Sections</h4>
                                    <div style={{display:'flex', gap: 10, marginBottom: 15}}>
                                        <button onClick={()=>addPageSection('card')} style={{background: '#6C5DD3', border:'none', color:'white', padding:'8px 12px', borderRadius:6, cursor:'pointer'}}>+ Add Text Card</button>
                                        <button onClick={()=>addPageSection('media')} style={{background: '#26A65B', border:'none', color:'white', padding:'8px 12px', borderRadius:6, cursor:'pointer'}}>+ Add Video/Image</button>
                                    </div>

                                    {/* SECTION LOOP */}
                                    {pageSections.map((section, index) => (
                                        <div key={section.id} style={{background: 'rgba(255,255,255,0.05)', borderRadius: 8, padding: 15, marginBottom: 15, border: '1px solid rgba(255,255,255,0.1)'}}>
                                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 10}}>
                                                <div style={{fontWeight: 'bold', color: section.type==='card' ? '#6C5DD3' : '#26A65B'}}>
                                                    {section.type === 'card' ? "📄 Glass Card" : "🎬 Standalone Media"}
                                                </div>
                                                <div style={{display:'flex', gap: 5}}>
                                                    <button onClick={()=>movePageSection(index, -1)} disabled={index===0} style={{cursor:'pointer', background:'transparent', border:'none', color:'white'}}>▲</button>
                                                    <button onClick={()=>movePageSection(index, 1)} disabled={index===pageSections.length-1} style={{cursor:'pointer', background:'transparent', border:'none', color:'white'}}>▼</button>
                                                    <input type="checkbox" checked={section.visible} onChange={(e)=>updatePageSection(index, 'visible', e.target.checked)} style={{cursor:'pointer', width:20, height:20}} title="Visible?" />
                                                    <button onClick={()=>removePageSection(index)} style={{color:'#FF5C5C', background:'transparent', border:'none', cursor:'pointer', marginLeft: 10}}>Delete</button>
                                                </div>
                                            </div>
                                            
                                            {section.type === 'card' && <RenderEditor value={section.content} onChange={(val) => updatePageSection(index, 'content', val)} />}
                                            {section.type === 'media' && (
                                                <div>
                                                    <label style={{color: '#8F9EB5', fontSize: 12}}>Image URL or YouTube/Twitch Link</label>
                                                    <input className="DarkInput" value={section.content} onChange={(e) => updatePageSection(index, 'content', e.target.value)} placeholder="https://..." />
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div style={{textAlign:'right', marginBottom:20}}>
                                    <button className="PrimaryButton" onClick={handleSavePage}>{pageEditingId?"Update Page":"Create Page"}</button>
                                </div>
                                
                                <hr style={{borderColor: 'rgba(255,255,255,0.1)', margin: '20px 0'}} />
                                
                                <h4>Existing Pages</h4>
                                {customPages.map(p => (
                                    <div key={p.id} style={{display:'flex', justifyContent:'space-between', padding: '10px', borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
                                        <span>{p.title} <small style={{color:'#6C5DD3'}}>(/{p.slug})</small></span>
                                        <div>
                                            <button onClick={()=>handleEditPage(p)} style={{color:'#6C5DD3', background:'none', border:'none', cursor:'pointer', marginRight:10}}>Edit</button>
                                            <button onClick={()=>handleDeletePage(p.id)} style={{color:'#FF5C5C', background:'none', border:'none', cursor:'pointer'}}>Delete</button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                        
                        {/* === USERS TAB === */}
                        {activeTab === 'users' && (
                            <div className="GlassCard" style={{ padding: 20 }}>
                                <h2 style={{ color: 'white', marginTop: 0 }}>User Roles & Team Assignment</h2>
                                <table style={{ width: '100%', color: 'white', textAlign: 'left', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
                                            <th style={{ padding: 10 }}>Email</th>
                                            <th style={{ padding: 10 }}>Role</th>
                                            <th style={{ padding: 10 }}>Team (For Captains)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allUsers.map(u => (
                                            <tr key={u.uid} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                                <td style={{ padding: 10 }}>{u.email}</td>
                                                <td style={{ padding: 10 }}>
                                                    <select 
                                                        className="DarkInput" 
                                                        style={{ margin: 0, padding: 5 }}
                                                        value={u.role || 'user'}
                                                        onChange={(e) => updateUserRoleData(u.uid, { role: e.target.value })}
                                                    >
                                                        <option value="commentator">Commentator</option>
                                                        <option value="captain">Captain</option>
                                                        <option value="admin">Admin</option>
                                                    </select>
                                                </td>
                                                <td style={{ padding: 10 }}>
                                                    <select 
                                                        className="DarkInput" 
                                                        style={{ margin: 0, padding: 5 }}
                                                        // Look for teamName, with a fallback just in case you already saved an ID during testing
                                                        value={u.teamName || ''} 
                                                        onChange={(e) => updateUserRoleData(u.uid, { teamName: e.target.value })}
                                                    >
                                                        <option value="">-- No Team --</option>
                                                        {teams.map(t => (
                                                            <option key={t.name} value={t.name}> {t.name} </option> 
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        
                        {/* === SCHEDULE TAB === */}
                        {activeTab === 'schedule' && (
                            <div>
                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                    <h3>{schedEditingId ? "Edit Match" : "Create Match"}</h3>
                                    {schedEditingId && <button onClick={cancelEditSched} style={{background:'transparent', border:'1px solid #555', color: '#aaa', borderRadius: 4, padding:'5px 10px', cursor:'pointer'}}>Cancel Edit</button>}
                                </div>
                                <div style={{background: 'rgba(0,0,0,0.2)', padding: 20, borderRadius: 12, margin: '15px 0'}}>
                                    <div style={{display:'grid', gridTemplateColumns: '1fr 1fr', gap: 15, marginBottom: 15}}>
                                        <div><label style={{fontSize:11, color:'#888'}}>Team 1</label><select className="DarkInput" value={schedForm.team1} onChange={e=>setSchedForm({...schedForm, team1: e.target.value})}><option value="">Select Team</option>{teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}</select></div>
                                        <div><label style={{fontSize:11, color:'#888'}}>Team 2</label><select className="DarkInput" value={schedForm.team2} onChange={e=>setSchedForm({...schedForm, team2: e.target.value})}><option value="">Select Team</option>{teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}</select></div>
                                        <div><label style={{fontSize:11, color:'#888'}}>Start Time</label><input type="datetime-local" className="DarkInput" value={schedForm.startTime} onChange={e=>setSchedForm({...schedForm, startTime: e.target.value})}/></div>
                                        <div><label style={{fontSize:11, color:'#888'}}>End Time</label><input type="datetime-local" className="DarkInput" value={schedForm.endTime} onChange={e=>setSchedForm({...schedForm, endTime: e.target.value})}/></div>
                                    </div>
                                    <input className="DarkInput" placeholder="Result" value={schedForm.result} onChange={e=>setSchedForm({...schedForm, result: e.target.value})} />
                                    
                                    <div style={{margin: '15px 0'}}>
                                        <label style={{fontSize:12, color:'#888', marginBottom: 5, display: 'block'}}>Stream Perspectives</label>
                                        {schedForm.links.map((linkObj, index) => (
                                            <div key={index} style={{display:'flex', gap: 10, marginBottom: 5, alignItems: 'center'}}>
                                                <input className="DarkInput" style={{margin:0, flex: 2}} placeholder="URL" value={linkObj.url} onChange={(e)=>handleLinkChange(index, 'url', e.target.value)}/>
                                                <input className="DarkInput" style={{margin:0, flex: 1}} placeholder="Label" value={linkObj.label} onChange={(e)=>handleLinkChange(index, 'label', e.target.value)}/>
                                                <select className="DarkInput" style={{margin:0, flex: 1}} value={linkObj.teamId} onChange={(e)=>handleLinkChange(index, 'teamId', e.target.value)}>
                                                    <option value="">Team?</option>
                                                    {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                                </select>
                                                <button onClick={()=>handleRemoveLink(index)} style={{background:'#FF5C5C', color:'white', border:'none', borderRadius: 8, width: 30, height: 30, cursor:'pointer'}}>✕</button>
                                            </div>
                                        ))}
                                        <button onClick={handleAddLink} style={{background:'transparent', border:'1px dashed #6C5DD3', color:'#6C5DD3', borderRadius: 8, width: '100%', padding: '8px', cursor:'pointer', fontSize: 13}}>+ Add Perspective</button>
                                    </div>
                                    <textarea className="DarkInput" placeholder="Notes" rows={2} value={schedForm.description} onChange={e=>setSchedForm({...schedForm, description: e.target.value})}/>
                                    <button className="PrimaryButton" style={{width:'100%'}} onClick={handleSchedSubmit}>{schedEditingId ? "Update" : "Create"}</button>
                                </div>
                                {schedule.map(item => (
                                    <div key={item.id} onClick={() => startEditSched(item)} style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding: 12, borderBottom: '1px solid rgba(255,255,255,0.05)', cursor: 'pointer', borderLeft: schedEditingId === item.id ? '4px solid #6C5DD3' : 'none', background: schedEditingId === item.id ? 'rgba(108,93,211,0.1)' : 'transparent'}}>
                                        <div><strong>{item.title}</strong><br/><small style={{color:'#888'}}>{item.startTime}</small></div>
                                        <button onClick={(e)=>{e.stopPropagation();deleteSched(item.id)}} style={{color:'#FF5C5C', background:'transparent', border:'none'}}>Delete</button>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* === TEAMS TAB === */}
                        {activeTab === 'teams' && (
                            <div>
                                {/* --- INPUT FORM --- */}
                                <div style={{display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end', marginBottom:20, background:'rgba(0,0,0,0.2)', padding:15, borderRadius:10}}>
                                    
                                    {/* Name Input */}
                                    <div style={{flex:1, minWidth: 150}}>
                                        <label style={{fontSize:11, color:'#888'}}>Name</label>
                                        <input className="DarkInput" style={{margin:0}} value={teamDraft.name} onChange={e=>setTeamDraft({...teamDraft, name:e.target.value})}/>
                                    </div>
                                    
                                    {/* Color Picker */}
                                    <div>
                                        <label style={{fontSize:11, color:'#888', display:'block'}}>Color</label>
                                        <input type="color" value={teamDraft.color} onChange={e=>setTeamDraft({...teamDraft, color:e.target.value})} style={{height:42, width:50, border:'none', background:'transparent', cursor:'pointer'}}/>
                                    </div>
                                    
                                    {/* OPTION A: SVG Upload */}
                                    <div style={{flex:1, minWidth: 150}}>
                                        <label style={{fontSize:11, color:'#888'}}>Option A: Upload SVG</label>
                                        <input 
                                            id="logo-upload" 
                                            type="file" 
                                            accept=".svg" 
                                            onChange={(e) => {
                                                handleLogoFileChange(e);
                                                // Clear the image URL if they upload an SVG
                                                setTeamDraft(prev => ({...prev, logoUrl: ""}));
                                            }} 
                                            style={{fontSize:12, color: '#ccc'}}
                                        />
                                    </div>

                                    {/* Separator */}
                                    <div style={{fontSize: 10, fontWeight: 'bold', color: '#666', paddingBottom: 12}}>OR</div>

                                    {/* OPTION B: Select Media Image */}
                                    <div style={{flex:1, minWidth: 150}}>
                                        <label style={{fontSize:11, color:'#888'}}>Option B: Select Media</label>
                                        <select 
                                            className="DarkInput" 
                                            style={{margin:0}} 
                                            value={teamDraft.logoUrl || ""} 
                                            onChange={(e) => {
                                                setTeamDraft({
                                                    ...teamDraft, 
                                                    logoUrl: e.target.value, 
                                                    logo: "" // Clear SVG if they select an image
                                                });
                                                // Reset the file input visually
                                                document.getElementById('logo-upload').value = "";
                                            }}
                                        >
                                            <option value="">-- No Image --</option>
                                            {AVAILABLE_IMAGES.map((img) => (
                                                <option key={img.filename} value={img.filename}>{img.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div style={{width: '100%', marginTop: 10}}>
                                        <label style={{fontSize:11, color:'#888'}}>Creator Bio (Shows in Home Carousel)</label>
                                        <textarea 
                                            className="DarkInput" 
                                            style={{margin:0, height: 80, resize: 'vertical'}} 
                                            value={teamDraft.bio || ""} 
                                            onChange={e => setTeamDraft({...teamDraft, bio: e.target.value})}
                                            placeholder="Tell the community about this creator..."
                                        />
                                    </div>

                                    {/* Preview & Submit */}
                                    <div style={{marginBottom: 5}}>{renderLogoPreview(teamDraft)}</div>
                                    
                                    <button className="PrimaryButton" onClick={handleTeamSubmit}>{teamEditingId?"Update":"Add"}</button>
                                    {teamEditingId && <button onClick={cancelEditTeam} style={{color:'#ccc', background:'none', border:'none', cursor:'pointer'}}>Cancel</button>}
                                </div>

                                {/* --- TEAMS LIST --- */}
                                {teams.map(t => (
                                    <div key={t.id} style={{display:'flex', alignItems:'center', padding:'10px', borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
                                        {/* Use new helper to render list item */}
                                        {renderLogoPreview(t)}
                                        
                                        <span style={{marginLeft:15, flex:1, fontWeight:'bold'}}>{t.name}</span>
                                        <button onClick={()=>startEditTeam(t)} style={{color:'#6C5DD3', background:'none', border:'none', cursor:'pointer', marginRight:10}}>Edit</button>
                                        <button onClick={()=>handleDeleteTeam(t.id)} style={{color:'#FF5C5C', background:'none', border:'none', cursor:'pointer'}}>Del</button>
                                    </div>
                                ))}
                            </div>
                        )}
                        {/* {activeTab === 'teams' && (
                            <div>
                                <div style={{display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end', marginBottom:20, background:'rgba(0,0,0,0.2)', padding:15, borderRadius:10}}>
                                    <div style={{flex:1}}><label style={{fontSize:11, color:'#888'}}>Name</label><input className="DarkInput" style={{margin:0}} value={teamDraft.name} onChange={e=>setTeamDraft({...teamDraft, name:e.target.value})}/></div>
                                    <div><label style={{fontSize:11, color:'#888', display:'block'}}>Color</label><input type="color" value={teamDraft.color} onChange={e=>setTeamDraft({...teamDraft, color:e.target.value})} style={{height:42, width:50, border:'none', background:'transparent', cursor:'pointer'}}/></div>
                                    <div style={{flex:1}}><label style={{fontSize:11, color:'#888'}}>Logo (SVG)</label><input id="logo-upload" type="file" accept=".svg" onChange={handleLogoFileChange} style={{fontSize:12}}/></div>
                                    {renderSvgPreview(teamDraft.logo)}
                                    <button className="PrimaryButton" onClick={handleTeamSubmit}>{teamEditingId?"Update":"Add"}</button>
                                    {teamEditingId && <button onClick={cancelEditTeam} style={{color:'#ccc', background:'none', border:'none', cursor:'pointer'}}>Cancel</button>}
                                </div>
                                {teams.map(t => (
                                    <div key={t.id} style={{display:'flex', alignItems:'center', padding:'10px', borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
                                        {t.logo ? renderSvgPreview(t.logo) : <div style={{width:30,height:30,background:t.color,borderRadius:4}}></div>}
                                        <span style={{marginLeft:15, flex:1, fontWeight:'bold'}}>{t.name}</span>
                                        <button onClick={()=>startEditTeam(t)} style={{color:'#6C5DD3', background:'none', border:'none', cursor:'pointer', marginRight:10}}>Edit</button>
                                        <button onClick={()=>handleDeleteTeam(t.id)} style={{color:'#FF5C5C', background:'none', border:'none', cursor:'pointer'}}>Del</button>
                                    </div>
                                ))}
                            </div>
                        )} */}
                        
                        {/* === NAVIGATION TAB === */}
                        {activeTab === 'nav' && (
                            <div>
                                <h3>Navigation Menu</h3>
                                <table style={{width: '100%', borderCollapse: 'collapse', marginTop: 20}}>
                                    <thead><tr style={{textAlign:'left', color:'#888'}}><th style={{width:50}}>Sort</th><th>Link</th><th>Visible?</th><th>Label</th></tr></thead>
                                    <tbody>
                                        {navDraft.map((item, idx) => (
                                            <tr key={idx} style={{borderBottom: '1px solid rgba(255,255,255,0.05)'}}>
                                                <td>
                                                    <button onClick={()=>moveNav(idx, -1)} disabled={idx===0} style={{cursor:'pointer', background:'transparent', border:'none', color: idx===0?'#444':'white'}}>▲</button>
                                                    <button onClick={()=>moveNav(idx, 1)} disabled={idx===navDraft.length-1} style={{cursor:'pointer', background:'transparent', border:'none', color: idx===navDraft.length-1?'#444':'white'}}>▼</button>
                                                </td>
                                                <td style={{padding: 10, color: '#8F9EB5', fontSize:13}}>{item.link}</td>
                                                <td style={{padding: 10}}><input type="checkbox" checked={item.visible !== false} onChange={()=>{const n=[...navDraft]; n[idx].visible=!n[idx].visible; setNavDraft(n);}} style={{width: 18, height: 18, cursor: 'pointer'}} /></td>
                                                <td style={{padding: 10}}><input className="DarkInput" style={{margin: 0, padding: 8}} value={item.title} onChange={(e) => {const n=[...navDraft]; n[idx].title=e.target.value; setNavDraft(n);}} /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div style={{textAlign:'right', marginTop: 20}}><button className="PrimaryButton" onClick={()=>saveWrapper(saveNavigation, navDraft, "Navigation Saved")}>Save Navigation</button></div>
                            </div>
                        )}

                        {/* === STYLE TAB === */}
                        {activeTab === 'style' && (
                            <div>
                                <h3>Global Styles</h3>
                                <div style={{marginBottom: 20}}>
                                    <label style={{color: '#8F9EB5', display: 'block', marginBottom: 5}}>Font Family</label>
                                    <select className="DarkInput" value={styleDraft.font} onChange={(e) => setStyleDraft({...styleDraft, font: e.target.value})}>
                                        <option value="Inter">Inter</option>
                                        <option value="Roboto">Roboto</option>
                                        <option value="Open Sans">Open Sans</option>
                                        <option value="Lato">Lato</option>
                                        <option value="Montserrat">Montserrat</option>
                                        <option value="Playfair Display">Playfair Display</option>
                                        <option value="Courier New">Courier New</option>
                                    </select>
                                </div>
                                <div style={{display:'grid', gridTemplateColumns: '1fr 1fr', gap: 20}}>
                                    <div><label style={{color: '#8F9EB5', display: 'block'}}>Accent Color</label><input type="color" value={styleDraft.accentColor} onChange={(e)=>setStyleDraft({...styleDraft, accentColor: e.target.value})} style={{height: 40, width: 60, border:'none', background:'transparent', cursor:'pointer'}} /></div>
                                    <div><label style={{color: '#8F9EB5', display: 'block'}}>Sidebar</label><input type="color" value={styleDraft.sidebarBg} onChange={(e)=>setStyleDraft({...styleDraft, sidebarBg: e.target.value})} style={{height: 40, width: 60, border:'none', background:'transparent', cursor:'pointer'}} /></div>
                                    <div><label style={{color: '#8F9EB5', display: 'block'}}>BG Start</label><input type="color" value={styleDraft.bgStart} onChange={(e)=>setStyleDraft({...styleDraft, bgStart: e.target.value})} style={{height: 40, width: 60, border:'none', background:'transparent', cursor:'pointer'}} /></div>
                                    <div><label style={{color: '#8F9EB5', display: 'block'}}>BG End</label><input type="color" value={styleDraft.bgEnd} onChange={(e)=>setStyleDraft({...styleDraft, bgEnd: e.target.value})} style={{height: 40, width: 60, border:'none', background:'transparent', cursor:'pointer'}} /></div>
                                </div>
                                <div style={{marginTop: 30}}>
                                    <button className="PrimaryButton" onClick={() => saveWrapper(saveGlobalStyle, styleDraft, "Style Saved")}>Save & Apply Styles</button>
                                    <button style={{marginLeft: 10, background:'transparent', border:'1px solid #555', color:'#ccc', padding:'12px 20px', borderRadius:12, cursor:'pointer'}} onClick={() => {if(window.confirm("Reset?")) saveWrapper(saveGlobalStyle, { font: 'Inter', accentColor: '#6C5DD3', bgStart: '#7e6cd9', bgEnd: '#4a32e1', sidebarBg: '#110e22', cardBg: 'rgba(20, 20, 35, 0.6)' }, "Reset Complete");}}>Reset Defaults</button>
                                </div>
                            </div>
                        )}

                        {/* === STANDINGS TAB === */}
                        {activeTab === 'standings' && (
                            <div>
                                <h3>Manage Standings</h3>
                                {standingsDraft.map((section, sIdx) => (
                                    <div key={section.id} style={{border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: 15, marginBottom: 20, background: 'rgba(0,0,0,0.2)'}}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 10}}>
                                            <input className="DarkInput" style={{width: 300, margin: 0}} value={section.title} onChange={(e)=>updateSectionTitle(sIdx, e.target.value)} placeholder="Bracket Name" />
                                            <button onClick={()=>removeSection(sIdx)} style={{color: '#FF5C5C', background: 'transparent', border: 'none', cursor:'pointer'}}>Delete</button>
                                        </div>
                                        <div style={{fontSize: 12, color: '#888', marginBottom: 10}}>
                                            Columns: {section.rows.length > 0 ? Object.keys(section.rows[0].stats).join(", ") : "W, L, Pts"}
                                            <button onClick={()=> {const name=prompt("New Column Name:"); if(name) addStatColumn(sIdx, name)}} style={{marginLeft: 10, background: '#333', border:'none', color: 'white', cursor:'pointer', padding: '2px 6px', borderRadius: 4}}>+</button>
                                        </div>
                                        {section.rows.map((row, rIdx) => (
                                            <div key={rIdx} style={{display: 'flex', gap: 10, marginBottom: 5, alignItems: 'center'}}>
                                                <select className="DarkInput" style={{width: 200, margin: 0}} value={row.teamId} onChange={(e)=>updateRowTeam(sIdx, rIdx, e.target.value)}><option value="">Select Team</option>{teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}</select>
                                                {Object.keys(row.stats).map(key => (
                                                    <div key={key} style={{width: 50}}><input className="DarkInput" style={{margin: 0, textAlign:'center', padding: 8}} value={row.stats[key]} onChange={(e)=>updateRowStat(sIdx, rIdx, key, e.target.value)} /></div>
                                                ))}
                                                <button onClick={()=>removeRow(sIdx, rIdx)} style={{color: '#FF5C5C', background: 'transparent', border: 'none', cursor:'pointer'}}>x</button>
                                            </div>
                                        ))}
                                        <button onClick={()=>addRowToSection(sIdx)} style={{marginTop: 10, background: 'transparent', border: '1px dashed #666', color: '#ccc', width: '100%', padding: 5, cursor: 'pointer'}}>+ Add Row</button>
                                    </div>
                                ))}
                                <button className="PrimaryButton" style={{background: '#333'}} onClick={addStandingSection}>+ Add New Bracket</button>
                                <div style={{textAlign:'right', marginTop:20}}><button className="PrimaryButton" onClick={handleSaveStandings}>Save All</button></div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Admin;
